import "rangeslider.js";
import axios from "axios";
import { Modal } from "bootstrap";

$('#subscriptionUpdateButton').click(function () {
    let yearlyCostElement = document.getElementById('yearly_cost_set')
    if (yearlyCostElement) {
        $('#increased_price').html(yearlyCostElement.innerHTML + ' will be charged pro-rata');
        return
    }
    $('#increased_price').html(document.getElementById('monthly_cost').innerHTML + ' will be charged pro-rata');

});


window.showNewUserSubscription = function (certs, selected_package) {
    let resp = calculatePricing(certs, selected_package);
    let costPerMonth = ((resp.costPerMonth)).toLocaleString();
    let costPerYear = ((resp.yearlyCost)).toLocaleString();
    let savingPerYear = ((resp.savingPerYear)).toLocaleString();

    $('#total_certs').html(certs);
    $('#planbigbox-certs').html(certs);
    $('#cost_pm').html('$' + costPerMonth);
    if (selected_package == 'monthly') {
        $('#selected_plan').html('Monthly')
        $('.certificate_test').addClass('planbox_text');
        $('#total_cost').html('$' + costPerMonth + '/mo');
        $('#planbigbox-cost').html('<b>$' + costPerMonth + '</b>/Month');
        $('.total_saving').addClass('d-none')
        $('.total_saving').removeClass('d-flex')
    } else {
        $('#selected_plan').html('Yearly')
        $('.total_saving').removeClass('d-none')
        $('.total_saving').addClass('d-flex')
        $('#total_saving').html('$' + savingPerYear);
        $('#total_cost').html('$' + costPerYear + '/year');
        $('#planbigbox-cost').html('<b>$' + costPerYear + '</b>/Year');
    }
}

window.updateSubscriptionNewUser = function () {
    let form = document.getElementById("selected_package")
    let resp = calculatePricing(certs, selected_package);
    let costPerMonth = ((resp.costPerMonth)).toLocaleString();
    let costPerYear = ((resp.yearlyCost)).toLocaleString();
    let savingPerYear = ((resp.savingPerYear)).toLocaleString();
    let plan = form.elements["package"].value
    let certs = form.elements["certs"].value
    let payload = {
        sub_monthly_price: costPerMonth,
        sub_yearly_price: costPerYear,
        sub_yearly_saving: savingPerYear,
        package: plan,
        certs
    }
    showNewUserSubscription(certs, plan)
    document.getElementById('dismissSubscriptionUpdateModal').click()
    axios.put('/update/session', { subscriptionData: payload }).then(function (response) {
        if (response.data.status) {
        }
    }).catch()
}

window.subscriptionUpdateStatus = function (status) {
    let disabledSubscriptionUpdateButton = document.getElementById('disabledSubscriptionUpdateButton')
    let subscriptionUpdateButton = document.getElementById('subscriptionUpdateButton')
    if (disabledSubscriptionUpdateButton && subscriptionUpdateButton) {
        if (status) {
            disabledSubscriptionUpdateButton.classList.add('d-none')
            subscriptionUpdateButton.classList.remove('d-none')
        } else {
            disabledSubscriptionUpdateButton.classList.remove('d-none')
            subscriptionUpdateButton.classList.add('d-none')
        }
    }
}

window.fetchSubscriptionButtonText = function () {
    let str = $('#subscriptionUpdateButton').text()
    str = str.replace(/\s+/g, '');
    return str
}

window.fetchCerts = function () {
    return document.getElementById('certs').value
}

window.fetchSubscriptionInfo = function () {
    let resp
    let form = document.getElementById("selected_package");
    if (!form) {
        return
    }
    let certs = fetchCerts()
    let selected_package = form.elements["package"].value
    let account_type = document.getElementById('account_type').value
    if (account_type && account_type === 'P') {
        resp = calculatePropertyManagerPricing(certs, selected_package)
    } else
        resp = calculatePricing(certs, selected_package)
    let packages = ['monthly', 'yearly', '2years', '3years']
    packages.forEach(function (non_selected_package) {
        let element = document.getElementById(non_selected_package);
        element.classList.remove("active-subscription");
    })

    document.getElementById(selected_package).classList.add("active-subscription");

    document.getElementById('range_value_update').innerHTML = (certs).toLocaleString()

    document.getElementById('monthly_cost').innerHTML = '$' + ((resp.costPerMonth)).toLocaleString()

    if (resp.costPerYear > 0 && resp.savingPerYear > 0) {
        document.getElementById('yearly_subscriptions_costs').innerHTML = '' +
            '<li class="mt-4"><span class="boldness h3-font">' +
            'Cost' +
            '</span>' +
            '<span id="yearly_cost_set" class="h3-font move-right">' +
            '$' +
            Number((resp.yearlyCost)).toLocaleString() +
            '/year' +
            '</span>' +
            '</li>' +
            '<li class="mt-4">' +
            '<span class="h3-font boldness">You Save</span>' +
            '<span class="h3-font move-right"> $' +
            Number((resp.savingPerYear)).toLocaleString() +
            '</span>' +
            '</li>'
    } else {
        document.getElementById('yearly_subscriptions_costs').innerHTML = ''
    }
}

window.subscriptionSlider = function () {

    console.log("setting up subscription slider");
    $('input[type="range"]').rangeslider({

        // Feature detection the default is `true`.
        // Set this to `false` if you want to use
        // the polyfill also in Browsers which support
        // the native <input type="range"> element.
        // polyfill: false,

        // Callback function
        onInit: function () {
            console.log("rangeslider init");

        },

        // Callback function
        onSlide: function (position, value) {
            if (value < 1) {
                $('input[name="certs"]').val(50).trigger('input');
            }
            fetchSubscriptionInfo()
            updateSubscriptionInfo();
        },

        // Callback function
        onSlideEnd: function (position, value) {
            if (document.getElementById('certificates')) {
                let certificates = parseInt(document.getElementById('certificates').value);

                if (certificates > value) {
                    let i = 50;
                    for (; i <= 1000; i = i + 50) {
                        if (certificates < i) {
                            $('input[type="range"]').val(i).trigger('input');
                            break;
                        }
                    }
                    document.getElementById('cert_error_div').classList.remove('d-none');
                    document.getElementById('cert_error_div').classList.add('d-flex');

                    document.getElementById('cert_error_text').innerHTML = 'You currently manage more than ' + value + ' certificates, to downgrade your subscription please delete 25 or more certificates.<a class="text-white remove-text-decoration pointer-cursor" href="/"> Go to partners </a>'

                }
            }
        }
    });
    updateSubscriptionInfo();
    fetchSubscriptionInfo()
    subscriptionUpdateStatus(fetchSubscriptionButtonText() !== 'UpdateSubscription')
}
window.subscriptionSelected = function () {
    fetchSubscriptionInfo()
}

$('#selected_package').dirrty({
    preventLeaving: false
}).on("dirty", function () {
    subscriptionUpdateStatus(true)
}).on("clean", function () {
    subscriptionUpdateStatus(fetchSubscriptionButtonText() !== 'UpdateSubscription')
});

window.updateSubscriptionInfo = function () {

    let form = document.getElementById('new-subscription-new-user')
    if (!form) return
    let selected_package = form.elements["package"].value
    if (selected_package == "monthly") {
        document.getElementById('month').classList.add('color')
        document.getElementById('monthly_price').classList.add('color')
    }
    else {
        document.getElementById('month').classList.remove('color')
        document.getElementById('monthly_price').classList.remove('color')
    }
    if (selected_package == "yearly") {
        document.getElementById('year').classList.add('color')
        document.getElementById('year_price').classList.add('color')
    }
    else {
        document.getElementById('year').classList.remove('color')
        document.getElementById('year_price').classList.remove('color')
    }
    if (selected_package == "2years") {
        document.getElementById('2year').classList.add('color')
        document.getElementById('2year_price').classList.add('color')
    }
    else {
        document.getElementById('2year').classList.remove('color')
        document.getElementById('2year_price').classList.remove('color')
    }
    if (selected_package == "3years") {
        document.getElementById('3year').classList.add('color')
        document.getElementById('3year_price').classList.add('color')
    }
    else {
        document.getElementById('3year').classList.remove('color')
        document.getElementById('3year_price').classList.remove('color')
    }
    let certs = form.elements["certs"].value
    let account_type = document.getElementById('account_type').value
    let resp
    if (account_type && account_type === 'P') {
        resp = calculatePropertyManagerPricing(certs, selected_package)
    } else
        resp = calculatePricing(certs, selected_package)
    $('#certs-value').html(certs)
    let monthly_cost = calculatePricing(certs, "monthly")
    console.log("monthly costs: ", monthly_cost);
    let yearly_cost = calculatePricing(certs, "yearly")
    let two_year_cost = calculatePricing(certs, '2years')
    let three_year_cost = calculatePricing(certs, '3years')
    let monthly_cost_element = document.getElementById('monthly_price')
    let yearly_cost_element = document.getElementById('year_price')
    let two_year_cost_element = document.getElementById('2year_price')
    let three_year_cost_element = document.getElementById('3year_price')
    let yearly_month_element = document.getElementById('year_month')
    let two_year_month_element = document.getElementById('2year_month')
    let three_year_month_element = document.getElementById('3year_month')
    monthly_cost_element.innerHTML = '$' + (monthly_cost.costPerMonth) + "/Month"
    yearly_cost_element.innerHTML = '$' + (yearly_cost.yearlyCost) + "/Year"
    yearly_cost_element.innerHTML = '$' + (yearly_cost.yearlyCost) + "/Year"
    two_year_cost_element.innerHTML = '$' + (two_year_cost.yearlyCost) + "/Year"
    three_year_cost_element.innerHTML = '$' + (three_year_cost.yearlyCost) + "/Year"
    yearly_month_element.innerHTML = '$' + (yearly_cost.costPerMonth) + "/Month"
    two_year_month_element.innerHTML = '$' + (two_year_cost.costPerMonth) + "/Month"
    three_year_month_element.innerHTML = '$' + (three_year_cost.costPerMonth) + "/Month"

}

function validateReferralCode (code) {
    axios.post('/referral/verify', {
        code
    }).then(function (resp) {
        if (!resp.data.status) {
            $('#trial-display').addClass("mt-5")
            $("#referral-invalid").removeClass("d-none");
        } else {
            $('#trial').html('30')
            $('#trial-end-date').html(resp.data.date)
        }
    })
}

window.contactUs = function () {
    let event = {
        name: 'csmr_subscription_contact',
        type: 'Action'
    }
    trackEvent(event)
    window.location.href = "mailto:info@c2coi.com"
}

function chooseSubscriptionPmTracking () {
    let form = document.getElementById('new-subscription-new-user')
    let selected_package = form.elements["package"].value
    let certs = form.elements["certs"].value
    let account_type = document.getElementById('account_type').value
    let resp
    if (account_type && account_type === 'P') {
        resp = calculatePropertyManagerPricing(certs, selected_package)
    } else
        resp = calculatePricing(certs, selected_package)
    let price
    if (resp.yearlyCost > 0) {
        price = resp.yearlyCost
    } else {
        price = resp.costPerMonth
    }

    let event = {
        name: 'pm_updatesubscription_choose',
        type: 'Action',
        attributes: {
            cert_number: certs,
            subscription_frequency: selected_package,
            amount: price,
        }
    }

    let referralCode = document.getElementById('referral-code').value
    if (referralCode && referralCode !== '') {
        event.attributes.referral_code = referralCode
    }
    trackEvent(event)
}

function applyVoucherCode (type) {
    $('#voucher-code-apply').prop('disabled', true);
    let voucher = $('#voucher-code').val()
    axios.post('/broker/verify/token', {
        voucher: voucher,
        type: type
    }).then(function (resp) {
        if (resp.data.status) {
            window.location.href = '/account/apply/referral?code=' + voucher
        } else {
            $('#voucher-code-apply').prop('disabled', false);
            $('#voucher-invalid').removeClass('d-none')
        }
    })
}

window.submit_subscription_form = function (type) {
    let voucher = $('#voucher-code').val()
    console.log(voucher);
    if (voucher != "") {
        axios.post('/broker/verify/token', {
            voucher: voucher,
            type: type
        }).then(function (resp) {
            if (resp.data.status) {
                console.log(resp.data.status)
                $('#voucher-invalid').addClass('d-none')
                $("#voucher_modal").modal('show')
                document.getElementById('voucher').value = voucher;
            }
            else {

                $('#voucher-invalid').removeClass('d-none')
            }
        })
    }
    else {
        document.getElementById("new-subscription-new-user").submit();
    }
}
window.submitVoucher = function () {
    let voucher = document.getElementById('voucher').value;
    window.location.href = '/account/apply/referral?code=' + voucher
}
window.payment_form = function () {
    var certs = $('#certs').val()
    var account_type = $('#account_type').val()
    let form = document.getElementById('new-subscription-new-user')
    var selected_package = form.elements["package"].value;
    var referral_code = form.elements["referral_code"].value;
    if (typeof form.elements["trial_period"] !== 'undefined') {
        var trial_period = form.elements["trial_period"].value;
    }
    else {
        var trial_period = null;
    }
    axios.post('auth/subscription', {
        certs: certs,
        account_type: account_type,
        selected_package: selected_package,
        referral_code: referral_code,
        trial_period
    }).then(function (resp) {
        var modalElement = document.getElementById('subscription');
        var modalInstance = new Modal(modalElement);

        modalElement.addEventListener('shown.bs.modal', function () {
            // Set modal to top of the page
            var modalDialog = modalElement.querySelector('.modal-dialog');
            modalDialog.style.position = 'absolute';
            modalDialog.style.top = '10px';
            modalDialog.style.left = '50%';
            modalDialog.style.transform = 'translateX(-50%)';
        });

        modalElement.addEventListener('hidden.bs.modal', function () {
            // Reset the modal position
            var modalDialog = modalElement.querySelector('.modal-dialog');
            modalDialog.style.position = '';
            modalDialog.style.top = '';
            modalDialog.style.left = '';
            modalDialog.style.transform = '';
        });

        // Prevent body from scrolling when the modal is open
        modalElement.addEventListener('shown.bs.modal', function () {
            document.body.classList.add('modal-open');
        });

        // Allow body scrolling when the modal is closed
        modalElement.addEventListener('hidden.bs.modal', function () {
            document.body.classList.remove('modal-open');
        });
        modalInstance.show();
        console.log(resp);
        document.getElementById('total_certs').innerHTML = resp.data.certs;
        if (resp.data.referral_code != null) {
            document.getElementById('referral_text').style.display = "block";
            var code = document.getElementById('referral_code');
            code.style.display = "block";
            code.innerHTML = resp.data.referral_code;
        }
        if (resp.data.referral_code != null) {
            document.getElementById('trail_days').innerHTML = "30";
        }
        else {
            document.getElementById('trail_days').innerHTML = "14";
        }
        if (resp.data.package == "yearly") {
            document.getElementById('time_span').innerHTML = "1 Year";
            document.getElementById('sub_total').innerHTML = "$" + (resp.data.pricing.yearlyCost).toFixed(2);
            document.getElementById('total').innerHTML = "$" + (resp.data.pricing.costPerYear).toFixed(2);
        }
        else if (resp.data.package == "2years") {
            document.getElementById('time_span').innerHTML = "2 Years";
            document.getElementById('sub_total').innerHTML = "$" + (resp.data.pricing.yearlyCost).toFixed(2);
            document.getElementById('total').innerHTML = "$" + (resp.data.pricing.costPerYear).toFixed(2);
        }
        else if (resp.data.package == "3years") {
            document.getElementById('time_span').innerHTML = "3 Years";
            document.getElementById('sub_total').innerHTML = "$" + (resp.data.pricing.yearlyCost).toFixed(2);
            document.getElementById('total').innerHTML = "$" + (resp.data.pricing.costPerYear).toFixed(2);
        }
        else {
            document.getElementById('time_span').innerHTML = "Monthly";
            document.getElementById('sub_total').innerHTML = "$" + (resp.data.pricing.costPerMonth).toFixed(2);
            document.getElementById('total').innerHTML = "$" + (resp.data.pricing.costPerMonth).toFixed(2);
        }
    })
}

window.cancelsubscription = function () {
    var closing_reason = document.getElementById('exampleFormControlTextarea1').value
    console.log(closing_reason);
    $("#cancel_subscription").modal('show');
    var text = document.getElementById('closing_reason').value = closing_reason;
}

jQuery(function() {
    window.subscriptionSlider();
});